import React from 'react';
import Header from './Header';
import Footer from './Footer';
import 'core/styles/public.css';

/** Shell for login / signup: site header + centred card on the brand backdrop + footer. */
function AuthLayout({ children, wide = false }) {
    return (
        <>
            <Header />
            <main className="jf-public jf-auth">
                <div className={`jf-auth-card${wide ? ' jf-auth-card--wide' : ''}`}>{children}</div>
            </main>
            <Footer />
        </>
    );
}

export default AuthLayout;
